export default __webpack_public_path__ + "static/media/imagefive.7f99146f.png";